


import React, { useEffect, useRef, useState } from "react";
import '../../App.css';

import { embedDashboard } from "@superset-ui/embedded-sdk";
import { CommonAxiosGet } from "../../CommonUtils/CommonAxios";
import { config } from "../../CommonUtils/CommonURLS";
function Superset() {
    function getGuestToken() {
        CommonAxiosGet(config.url.API_URL + 'dashboard/guest-token', {})
            .then(function (response) {
                console.log("Guest Token Response:", response);
                embedDashboard({
                    id: "f576b26d-f3c5-4f91-ad87-e4d130f590d4",
                    supersetDomain: "https://supersetpreprd.apcfss.in/",
                    mountPoint: document.getElementById("superset-container"), // ✅ matches JSX below
                    fetchGuestToken: () => response?.data?.token,
                    dashboardUiConfig: { hideTitle: true }
                });
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    // Call getGuestToken when component mounts
    React.useEffect(() => {
        getGuestToken();
    }, []);

    return (
        <>
            <h4>Affiliation Dashboard</h4>
            <div
                id="superset-container"
                style={{ width: "100vw", height: "22vh" }}
            ></div>
        </>
    );
}

export default Superset;

